const initialvalues = {
    paymentlogintapout: "",
    setOwnerDetailsbyRadiologintapout: [],
    setfilterOwnerDetailsbyRadiologintapout: [],
    setDueDetailslogintapout: [],
    bakFlaglogintapout: false,
    backFlag1logintapout: "fresh",
    formikValueslogintapout: {}
}
    

export default function OutsideTradelicensereducer(details = initialvalues, action) {


    switch (action.type) {
        case "OUTTRADEPAYMENTLOGIN":
            return { ...details, paymentlogintapout: action.payload };

        case "OUTTRADESETOWNERDETAILSBYRADIOLOGIN":
            return { ...details, setOwnerDetailsbyRadiologintapout: action.payload };
        case "OUTTRADESETFILTEROWNERDETAILSBYRADIOLOGIN":
            return { ...details, setfilterOwnerDetailsbyRadiologintapout: action.payload };
        case "OUTTRADESETDUEDETAILSLOGIN":
            return { ...details, setDueDetailslogintapout: action.payload };

        case "OUTTRADEFORMIKVALUESLOGIN":
            return { ...details, formikValueslogintapout: action.payload };
        case "OUTTRADEBACKFLAGLOGIN":
            return { ...details, bakFlaglogintapout: action.payload };
        case "OUTTRADEBACKFLAG1LOGIN":
            return { ...details, backFlag1logintapout: action.payload };

        default:
            return details;
    }
}